module.exports = __webpack_public_path__ + "static/img/steps_app3.f246042.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/steps_app3.png
// module id = 338
// module chunks = 1